import useCredits from './useCredits';
import useFeatureFlag from './useFeatureFlag';
import { useOnboardingCreditsPolling } from './useOnboardingCreditsPolling';
import { useUserPreferences } from '../services/userPreferences';
import { FEATURE_FLAGS } from '../constants/FeatureFlag';
import { UserPreferences } from '../services/userPreferences/types';

type NewOnboardingStepKey =
  | 'onboardingOabCompleted'
  | 'onboardingProfileCompleted'
  | 'onboardingToolsCompleted';

export function useNewOnboardingEligibility(completedKey: NewOnboardingStepKey) {
  const { isRestricted, isLoading: isSubscriptionLoadingRaw } =
    useCredits();
  const { isPolling: isPollingCredits } = useOnboardingCreditsPolling();
  const { isFeatureFlagEnable, flagResolved } = useFeatureFlag(
    FEATURE_FLAGS.RELEASE.NEW_ONBOARDING,
  );
  const {
    preferences,
    isLoading: isPreferencesLoading,
    isError: isPreferencesError,
    updateUserPreferencesAsync,
  } = useUserPreferences();

  const completed = Boolean((preferences as UserPreferences)[completedKey]);

  const isSubscriptionLoading = isSubscriptionLoadingRaw || isPollingCredits;

  const baseEligible =
    !isRestricted &&
    isFeatureFlagEnable &&
    !isPreferencesError &&
    !isPreferencesLoading;

  const isEligible = baseEligible && !completed && !isPollingCredits;

  return {
    isEligible,
    baseEligible,
    completed,
    preferences,
    isSubscriptionLoading,
    isPollingCredits,
    flagResolved,
    isPreferencesLoading,
    updateUserPreferencesAsync,
  };
}
